import * as Types from "../../../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type GetManageTokenCollectionQueryVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
  first: Types.Maybe<Types.Scalars["Float"]>;
  firstHashes: Types.Maybe<Types.Scalars["Float"]>;
}>;

export type GetManageTokenCollectionQuery = {
  getCollection: {
    __typename: "Collection";
    id: string;
    name: string;
    type: Types.CollectionContractType;
    address: string;
    chainId: number;
    collectionType: Types._CollectionType;
    description: string | null;
    editionId: number | null;
    status: Types.CollectionStatus;
    openSeaCollectionUrl: string | null;
    usingOpenseaBlocklist: boolean | null;
    size: number | null;
    supply: number | null;
    reveal: boolean | null;
    contractUri: string | null;
    baseUri: string | null;
    onChainBaseUri: string | null;
    revealClaimedIds: Array<number> | null;
    creditCardEnabled: boolean | null;
    hidden: boolean | null;
    nonTransferable: boolean | null;
    editions: Array<{
      __typename: "EditionToken";
      name: string;
      description: string;
      image: string;
      animation: string | null;
      size: number;
      onChainImage: string;
      onChainMetadata: string | null;
      nonTransferable: boolean | null;
      royalty: {
        __typename: "V1Royalty";
        royaltyRecipient: string | null;
        royaltyPercentageString: string | null;
      } | null;
      attributes: Array<{
        __typename: "TokenMetadataAttribute";
        trait_type: string;
        value: string;
      }> | null;
    }> | null;
    tokens: Array<{
      __typename: "GeneralToken";
      animation_url: string | null;
      image: string;
      name: string;
      description: string;
      id: string;
      nonTransferable: boolean | null;
      royalty: {
        __typename: "V1Royalty";
        royaltyPercentageString: string | null;
        royaltyRecipient: string | null;
      } | null;
    }> | null;
    importData: {
      __typename: "ImportData";
      description: string | null;
      media: string | null;
      standard: string | null;
      royalty: {
        __typename: "V1Royalty";
        royaltyRecipient: string | null;
        royaltyPercentageString: string | null;
      } | null;
    } | null;
    royalty: {
      __typename: "V1Royalty";
      royaltyPercentageString: string | null;
      royaltyRecipient: string | null;
    } | null;
    seriesTokens: {
      __typename: "SeriesTokensPaginated";
      allMintedTokenIds: Array<number> | null;
      edges: Array<{
        __typename: "SeriesToken";
        imageUrl: string | null;
        tokenId: string | null;
        name: string;
        attributes: Array<{
          __typename: "SeriesTokenAttribute";
          name: string;
          value: string;
        }>;
      }>;
      pageInfo: { __typename: "CursorPaginatedInfo"; totalCount: number };
    } | null;
    genSeriesHashes: {
      __typename: "GenSeriesHashesPaginated";
      edges: Array<{
        __typename: "GenSeriesHash";
        tokenId: number | null;
        hash: string;
      }>;
    } | null;
    seriesDetails: {
      __typename: "SeriesDetails";
      coverImage: number;
      mintPreviewImages: Array<number>;
      mintPreviewImageUrls: Array<string> | null;
      showAllMetadata: boolean | null;
      mirroredBaseUri: string | null;
      logoUrl: string | null;
      featuredTokenId: string | null;
    } | null;
    generativeDetails: {
      __typename: "GenerativeDetails";
      logoUrl: string | null;
      generativeCodeUri: string;
      mirroredBaseUri: string | null;
      allowedHashes: Array<string> | null;
      featuredTokenId: string | null;
    } | null;
    contract: {
      __typename: "Contract2";
      id: string;
      address: string | null;
      contractType: Types.ContractEntityType;
      name: string;
      symbol: string;
    } | null;
    mintVectors: Array<{
      __typename: "MintVector";
      id: string | null;
      gateId: string | null;
      start: string;
      end: string | null;
      price: string;
      chainId: number | null;
      currency: string;
      maxPerTxn: number;
      maxPerUser: number;
      maxPerVector: number;
      paused: boolean | null;
      paymentRecipient: string;
      ethRate: string;
      sponsored: boolean | null;
      editionId: number | null;
      priceType: Types.PriceType | null;
      scheduledPrices: Array<string> | null;
      isDirectMint: boolean | null;
      onchainMintVectorId: string | null;
      collectorMessage: string | null;
      name: string | null;
      isPublic: boolean;
      paymentCurrency: {
        __typename: "Currency";
        symbol: Types.CurrencySymbol;
        type: Types.CurrencyType;
        mintFee: string;
        decimals: number;
        address: string;
      } | null;
      stats: {
        __typename: "MintVectorStats";
        total: number;
        sold: number;
        status: Types.MintVectorStatus;
        earned: string | null;
        onchainDutchAuctionStats: {
          __typename: "OnchainDutchAuctionStats";
          earnedAmountIsValid: boolean;
          inFPP: boolean;
          exhausted: boolean;
          revenueWithdrawnFromEscrow: boolean;
          fundsToClaim: string;
          currentPrice: string;
        } | null;
      } | null;
      priceDrops: Array<{
        __typename: "PriceDrop";
        price: string;
        end: string;
        active: boolean;
      }> | null;
      priceDropInterval: Array<{
        __typename: "PriceDropTimePeriod";
        unit: Types.TimeUnit;
        value: number;
      }> | null;
      rankedAuction: {
        __typename: "RankedAuctionSettings";
        reserveBidAmount: string | null;
        rebateWinningBids: boolean | null;
      } | null;
    }>;
    crossmint: {
      __typename: "CrossmintEnv";
      collectionId: string;
      environment: string;
    } | null;
    flagVariations: {
      __typename: "CollectionFlagVariations";
      multipleMintVectorsEnableManagement: boolean;
      multipleMintVectorsEnableMultipleDA: boolean;
    };
  };
};

export type GetManageTokenMintVectorsQueryVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
}>;

export type GetManageTokenMintVectorsQuery = {
  getMintVectorsByCollection: Array<{
    __typename: "MintVector";
    id: string | null;
    gateId: string | null;
    start: string;
    end: string | null;
    price: string;
    chainId: number | null;
    currency: string;
    maxPerTxn: number;
    maxPerUser: number;
    maxPerVector: number;
    paused: boolean | null;
    paymentRecipient: string;
    ethRate: string;
    sponsored: boolean | null;
    stats: {
      __typename: "MintVectorStats";
      total: number;
      sold: number;
      status: Types.MintVectorStatus;
      earned: string | null;
      onchainDutchAuctionStats: {
        __typename: "OnchainDutchAuctionStats";
        earnedAmountIsValid: boolean;
        inFPP: boolean;
        exhausted: boolean;
        revenueWithdrawnFromEscrow: boolean;
      } | null;
    } | null;
  }>;
};

export type GetManageTokenAuctionsQueryVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
}>;

export type GetManageTokenAuctionsQuery = {
  getAuctionsByCollection: Array<{
    __typename: "Auction";
    chainId: number | null;
    collectionId: string;
    currency: string;
    end: string;
    gateId: string | null;
    paused: boolean | null;
    id: string | null;
    price: string;
    start: string;
    tokenId: string;
    stats: {
      __typename: "AuctionStats";
      currentBid: number;
      highestBidder: string;
      totalBids: number;
      status: Types.AuctionStatus;
    } | null;
  }>;
};

export type AllTransactionArgFieldsFragment = {
  __typename: "TransactionArgs";
  chainId: number;
  address: string | null;
  args: string;
  method: string | null;
  value: string | null;
  bytecode: string | null;
  gasLimit: string | null;
};

export type UpdateManageTokenMintVectorMutationVariables = Types.Exact<{
  data: Types.UpdateMintVectorInput;
}>;

export type UpdateManageTokenMintVectorMutation = {
  updateMintVector: { __typename: "MintVector"; id: string | null };
};

export type UpdateAuctionMutationVariables = Types.Exact<{
  data: Types.AuctionUpdateInput;
}>;

export type UpdateAuctionMutation = {
  auctionUpdate: {
    __typename: "AuctionUpdateOutput";
    id: string | null;
    contract: {
      __typename: "TransactionArgs";
      address: string | null;
      args: string;
      chainId: number;
      method: string | null;
      value: string | null;
      bytecode: string | null;
    } | null;
  };
};

export type GetManageImportTokenQueryVariables = Types.Exact<{
  tokenId: Types.Scalars["String"];
}>;

export type GetManageImportTokenQuery = {
  getImportedToken: {
    __typename: "ImportedToken";
    id: string;
    name: string;
    address: string;
    tokenId: string | null;
    chainId: number;
    importData: {
      __typename: "ImportData";
      description: string | null;
      media: string | null;
      standard: string | null;
    } | null;
  };
};

export type GetRankedAuctionEarningsQueryVariables = Types.Exact<{
  mintVectorId: Types.Scalars["String"];
}>;

export type GetRankedAuctionEarningsQuery = {
  rankedAuction: {
    __typename: "RankedAuction";
    id: string;
    auctionEarningsClaimed: boolean | null;
  };
};

export type GetManageTokenGateQueryVariables = Types.Exact<{
  id: Types.Scalars["String"];
}>;

export type GetManageTokenGateQuery = {
  gate: { __typename: "Gate"; id: string; name: string };
};

export type CollectionDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars["String"];
}>;

export type CollectionDeleteMutation = {
  collectionDelete: {
    __typename: "CollectionDeleteResult";
    deletedCount: number;
  };
};

export type DeleteImportedTokenMutationVariables = Types.Exact<{
  tokenId: Types.Scalars["String"];
}>;

export type DeleteImportedTokenMutation = {
  deleteImportedToken: {
    __typename: "ImportedTokenDeleteResult";
    deletedCount: number;
  };
};

export type UpdateCollectionMetadataMutationVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
  data: Types.CollectionMetadataUpdate;
}>;

export type UpdateCollectionMetadataMutation = {
  updateCollectionMetadata: {
    __typename: "TransactionArgs";
    chainId: number;
    address: string | null;
    args: string;
    method: string | null;
    value: string | null;
    bytecode: string | null;
    gasLimit: string | null;
  };
};

export type UpdateCollectionOffChainMutationVariables = Types.Exact<{
  data: Types.CollectionUpdateInput;
  collectionId: Types.Scalars["String"];
}>;

export type UpdateCollectionOffChainMutation = {
  collectionUpdate: {
    __typename: "Collection";
    creditCardEnabled: boolean | null;
    crossmint: {
      __typename: "CrossmintEnv";
      collectionId: string;
      environment: string;
    } | null;
  };
};

export type CreateManageTokenMintVectorMutationVariables = Types.Exact<{
  data: Types.CreateMintVectorInput;
}>;

export type CreateManageTokenMintVectorMutation = {
  createMintVector: { __typename: "MintVector"; id: string | null };
};

export type GetUpdateMintVectorTxArgsQueryVariables = Types.Exact<{
  mintVectorId: Types.Scalars["String"];
  data: Types.OnChainMintVectorUpdateInput;
}>;

export type GetUpdateMintVectorTxArgsQuery = {
  mintVectorUpdateTxArgs: {
    __typename: "TransactionArgs";
    chainId: number;
    address: string | null;
    args: string;
    method: string | null;
    value: string | null;
    bytecode: string | null;
    gasLimit: string | null;
  };
};

export type GetCreateMintVectorTxArgsQueryVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
  data: Types.OnChainMintVectorCreateInput;
}>;

export type GetCreateMintVectorTxArgsQuery = {
  mintVectorCreateTxArgs: {
    __typename: "TransactionArgs";
    chainId: number;
    address: string | null;
    args: string;
    method: string | null;
    value: string | null;
    bytecode: string | null;
    gasLimit: string | null;
  };
};

export type GetUpdateDutchAuctionTxArgsQueryVariables = Types.Exact<{
  mintVectorId: Types.Scalars["String"];
  data: Types.OnChainDutchAuctionUpdateInput;
}>;

export type GetUpdateDutchAuctionTxArgsQuery = {
  dutchAuctionUpdateTxArgs: {
    __typename: "TransactionArgs";
    chainId: number;
    address: string | null;
    args: string;
    method: string | null;
    value: string | null;
    bytecode: string | null;
    gasLimit: string | null;
  };
};

export type GetUpdateRankedAuctionTxArgsQueryVariables = Types.Exact<{
  mintVectorId: Types.Scalars["String"];
  data: Types.OnChainRankedAuctionUpdateInput;
}>;

export type GetUpdateRankedAuctionTxArgsQuery = {
  rankedAuctionUpdateTxArgs: {
    __typename: "TransactionArgs";
    chainId: number;
    address: string | null;
    args: string;
    method: string | null;
    value: string | null;
    bytecode: string | null;
    gasLimit: string | null;
  };
};

export type GetUpdatePauseRankedAuctionTxArgsQueryVariables = Types.Exact<{
  mintVectorId: Types.Scalars["String"];
  paused: Types.Scalars["Boolean"];
}>;

export type GetUpdatePauseRankedAuctionTxArgsQuery = {
  rankedAuctionUpdatePauseTxArgs: {
    __typename: "TransactionArgs";
    chainId: number;
    address: string | null;
    args: string;
    method: string | null;
    value: string | null;
    bytecode: string | null;
    gasLimit: string | null;
  };
};

export type GetClaimRankedAuctionEarningsTxArgsQueryVariables = Types.Exact<{
  mintVectorId: Types.Scalars["String"];
}>;

export type GetClaimRankedAuctionEarningsTxArgsQuery = {
  rankedAuctionClaimAuctionEarningsTxArgs: {
    __typename: "TransactionArgs";
    chainId: number;
    address: string | null;
    args: string;
    method: string | null;
    value: string | null;
    bytecode: string | null;
    gasLimit: string | null;
  };
};

export type GetUpdatePauseDutchAuctionTxArgsQueryVariables = Types.Exact<{
  mintVectorId: Types.Scalars["String"];
  paused: Types.Scalars["Boolean"];
}>;

export type GetUpdatePauseDutchAuctionTxArgsQuery = {
  dutchAuctionUpdatePauseTxArgs: {
    __typename: "TransactionArgs";
    chainId: number;
    address: string | null;
    args: string;
    method: string | null;
    value: string | null;
    bytecode: string | null;
    gasLimit: string | null;
  };
};

export type GetCreateDutchAuctionTxArgsQueryVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
  data: Types.OnChainDutchAuctionCreateInput;
}>;

export type GetCreateDutchAuctionTxArgsQuery = {
  dutchAuctionMechanicVectorCreateTxArgs: {
    __typename: "TransactionArgs";
    chainId: number;
    address: string | null;
    args: string;
    method: string | null;
    value: string | null;
    bytecode: string | null;
    gasLimit: string | null;
  };
};

export type GetClaimFundsDutchAuctionTxArgsQueryVariables = Types.Exact<{
  vectorId: Types.Scalars["String"];
}>;

export type GetClaimFundsDutchAuctionTxArgsQuery = {
  dutchAuctionClaimFundsTxArgs: {
    __typename: "TransactionArgs";
    chainId: number;
    address: string | null;
    args: string;
    method: string | null;
    value: string | null;
    bytecode: string | null;
    gasLimit: string | null;
  };
};

export type CrossmintStatusQueryVariables = Types.Exact<{
  isTestnet: Types.Scalars["Boolean"];
  cmCollectionId: Types.Scalars["String"];
}>;

export type CrossmintStatusQuery = {
  crossmintVerificationStatus: {
    __typename: "CrossmintVerificationStatus";
    id: string;
    seller: { __typename: "CrossmintSellerStatus"; status: string };
    collection: { __typename: "CrossmintCollectionStatus"; status: string };
  };
};

export type GetCreatorReservesTxArgsQueryVariables = Types.Exact<{
  collectionId: Types.Scalars["String"];
  data: Types.CreatorReservesInput;
}>;

export type GetCreatorReservesTxArgsQuery = {
  creatorReservesTxArgs: {
    __typename: "TransactionArgs";
    chainId: number;
    address: string | null;
    args: string;
    method: string | null;
    value: string | null;
    bytecode: string | null;
    gasLimit: string | null;
  };
};

export type UpdatePaymentRecipientOnPrivateSalesMutationVariables =
  Types.Exact<{
    collectionId: Types.Scalars["String"];
    paymentRecipient: Types.Scalars["String"];
  }>;

export type UpdatePaymentRecipientOnPrivateSalesMutation = {
  updatePaymentRecipientOnPrivateSales: boolean;
};

export type CollectionTokensQueryVariables = Types.Exact<{
  chainId: Types.Scalars["Float"];
  tokenAddress: Types.Scalars["String"];
  first: Types.Maybe<Types.Scalars["Float"]>;
  after: Types.Maybe<Types.Scalars["String"]>;
  sortBy: Types.Maybe<Types.TokenSortOptions>;
  sortDirection: Types.Maybe<Types.SortDirection>;
  tokenNameOrId: Types.Maybe<Types.Scalars["String"]>;
  withListings: Types.Maybe<Types.Scalars["Boolean"]>;
  withOffers: Types.Maybe<Types.Scalars["Boolean"]>;
  attributes: Types.Maybe<
    | Array<Types.MarketplaceCollectionAttributesFilter>
    | Types.MarketplaceCollectionAttributesFilter
  >;
  minted: Types.Maybe<Types.Scalars["Boolean"]>;
}>;

export type CollectionTokensQuery = {
  getCollectionTokens: {
    __typename: "MarketplaceTokensPaginated";
    edges: Array<{
      __typename: "MarketplaceTokenWithStats";
      id: string;
      tokenId: string;
      name: string;
      imageUrl: string;
      animationUrl: string | null;
      minted: boolean;
    }>;
    pageInfo: {
      __typename: "CursorPaginatedInfo";
      hasNextPage: boolean;
      endCursor: string | null;
      totalCount: number;
    };
  };
};

export const AllTransactionArgFieldsFragmentDoc = gql`
  fragment AllTransactionArgFields on TransactionArgs {
    chainId
    address
    args
    method
    value
    bytecode
    gasLimit
  }
`;
export const GetManageTokenCollectionDocument = gql`
  query GetManageTokenCollection(
    $collectionId: String!
    $first: Float
    $firstHashes: Float
  ) {
    getCollection(collectionId: $collectionId) {
      id
      name
      type
      address
      chainId
      collectionType
      description
      editionId
      editions {
        name
        description
        image
        animation
        size
        onChainImage
        onChainMetadata
        royalty {
          royaltyRecipient
          royaltyPercentageString
        }
        nonTransferable
        attributes {
          trait_type
          value
        }
      }
      tokens {
        animation_url
        image
        name
        description
        id
        nonTransferable
        royalty {
          royaltyPercentageString
          royaltyRecipient
        }
      }
      status
      openSeaCollectionUrl
      usingOpenseaBlocklist
      importData {
        description
        media
        royalty {
          royaltyRecipient
          royaltyPercentageString
        }
        standard
      }
      royalty {
        royaltyPercentageString
        royaltyRecipient
      }
      seriesTokens(first: $first) {
        edges {
          imageUrl
          tokenId
          name
          attributes {
            name
            value
          }
        }
        pageInfo {
          totalCount
        }
        allMintedTokenIds
      }
      genSeriesHashes(first: $firstHashes) {
        edges {
          tokenId
          hash
        }
      }
      size
      supply
      seriesDetails {
        coverImage
        mintPreviewImages
        mintPreviewImageUrls
        showAllMetadata
        mirroredBaseUri
        logoUrl
        featuredTokenId
      }
      generativeDetails {
        logoUrl
        generativeCodeUri
        mirroredBaseUri
        generativeCodeUri
        allowedHashes
        featuredTokenId
      }
      reveal
      contractUri
      baseUri
      onChainBaseUri
      contract {
        id
        address
        contractType
        name
        symbol
      }
      mintVectors {
        id
        gateId
        start
        end
        price
        chainId
        currency
        paymentCurrency {
          symbol
          type
          mintFee
          decimals
          address
        }
        maxPerTxn
        maxPerUser
        maxPerVector
        paused
        paymentRecipient
        ethRate
        sponsored
        stats {
          total
          sold
          status
          earned
          onchainDutchAuctionStats {
            earnedAmountIsValid
            inFPP
            exhausted
            revenueWithdrawnFromEscrow
            fundsToClaim
            currentPrice
          }
        }
        editionId
        priceDrops {
          price
          end
          active
        }
        priceType
        scheduledPrices
        priceDropInterval {
          unit
          value
        }
        rankedAuction {
          reserveBidAmount
          rebateWinningBids
        }
        isDirectMint
        onchainMintVectorId
        collectorMessage
        name
        isPublic
      }
      revealClaimedIds
      creditCardEnabled
      crossmint {
        collectionId
        environment
      }
      flagVariations {
        multipleMintVectorsEnableManagement
        multipleMintVectorsEnableMultipleDA
      }
      hidden
      nonTransferable
    }
  }
`;

/**
 * __useGetManageTokenCollectionQuery__
 *
 * To run a query within a React component, call `useGetManageTokenCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageTokenCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageTokenCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      first: // value for 'first'
 *      firstHashes: // value for 'firstHashes'
 *   },
 * });
 */
export function useGetManageTokenCollectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetManageTokenCollectionQuery,
    GetManageTokenCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetManageTokenCollectionQuery,
    GetManageTokenCollectionQueryVariables
  >(GetManageTokenCollectionDocument, options);
}
export function useGetManageTokenCollectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManageTokenCollectionQuery,
    GetManageTokenCollectionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetManageTokenCollectionQuery,
    GetManageTokenCollectionQueryVariables
  >(GetManageTokenCollectionDocument, options);
}
export type GetManageTokenCollectionQueryHookResult = ReturnType<
  typeof useGetManageTokenCollectionQuery
>;
export type GetManageTokenCollectionLazyQueryHookResult = ReturnType<
  typeof useGetManageTokenCollectionLazyQuery
>;
export type GetManageTokenCollectionQueryResult = Apollo.QueryResult<
  GetManageTokenCollectionQuery,
  GetManageTokenCollectionQueryVariables
>;
export const GetManageTokenMintVectorsDocument = gql`
  query GetManageTokenMintVectors($collectionId: String!) {
    getMintVectorsByCollection(collectionId: $collectionId) {
      id
      gateId
      start
      end
      price
      chainId
      currency
      maxPerTxn
      maxPerUser
      maxPerVector
      paused
      paymentRecipient
      ethRate
      sponsored
      stats {
        total
        sold
        status
        earned
        onchainDutchAuctionStats {
          earnedAmountIsValid
          inFPP
          exhausted
          revenueWithdrawnFromEscrow
        }
      }
    }
  }
`;

/**
 * __useGetManageTokenMintVectorsQuery__
 *
 * To run a query within a React component, call `useGetManageTokenMintVectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageTokenMintVectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageTokenMintVectorsQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetManageTokenMintVectorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetManageTokenMintVectorsQuery,
    GetManageTokenMintVectorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetManageTokenMintVectorsQuery,
    GetManageTokenMintVectorsQueryVariables
  >(GetManageTokenMintVectorsDocument, options);
}
export function useGetManageTokenMintVectorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManageTokenMintVectorsQuery,
    GetManageTokenMintVectorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetManageTokenMintVectorsQuery,
    GetManageTokenMintVectorsQueryVariables
  >(GetManageTokenMintVectorsDocument, options);
}
export type GetManageTokenMintVectorsQueryHookResult = ReturnType<
  typeof useGetManageTokenMintVectorsQuery
>;
export type GetManageTokenMintVectorsLazyQueryHookResult = ReturnType<
  typeof useGetManageTokenMintVectorsLazyQuery
>;
export type GetManageTokenMintVectorsQueryResult = Apollo.QueryResult<
  GetManageTokenMintVectorsQuery,
  GetManageTokenMintVectorsQueryVariables
>;
export const GetManageTokenAuctionsDocument = gql`
  query GetManageTokenAuctions($collectionId: String!) {
    getAuctionsByCollection(collectionId: $collectionId) {
      chainId
      collectionId
      currency
      end
      gateId
      paused
      id
      price
      start
      tokenId
      stats {
        currentBid
        highestBidder
        totalBids
        status
      }
    }
  }
`;

/**
 * __useGetManageTokenAuctionsQuery__
 *
 * To run a query within a React component, call `useGetManageTokenAuctionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageTokenAuctionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageTokenAuctionsQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetManageTokenAuctionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetManageTokenAuctionsQuery,
    GetManageTokenAuctionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetManageTokenAuctionsQuery,
    GetManageTokenAuctionsQueryVariables
  >(GetManageTokenAuctionsDocument, options);
}
export function useGetManageTokenAuctionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManageTokenAuctionsQuery,
    GetManageTokenAuctionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetManageTokenAuctionsQuery,
    GetManageTokenAuctionsQueryVariables
  >(GetManageTokenAuctionsDocument, options);
}
export type GetManageTokenAuctionsQueryHookResult = ReturnType<
  typeof useGetManageTokenAuctionsQuery
>;
export type GetManageTokenAuctionsLazyQueryHookResult = ReturnType<
  typeof useGetManageTokenAuctionsLazyQuery
>;
export type GetManageTokenAuctionsQueryResult = Apollo.QueryResult<
  GetManageTokenAuctionsQuery,
  GetManageTokenAuctionsQueryVariables
>;
export const UpdateManageTokenMintVectorDocument = gql`
  mutation UpdateManageTokenMintVector($data: UpdateMintVectorInput!) {
    updateMintVector(data: $data) {
      id
    }
  }
`;
export type UpdateManageTokenMintVectorMutationFn = Apollo.MutationFunction<
  UpdateManageTokenMintVectorMutation,
  UpdateManageTokenMintVectorMutationVariables
>;

/**
 * __useUpdateManageTokenMintVectorMutation__
 *
 * To run a mutation, you first call `useUpdateManageTokenMintVectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManageTokenMintVectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManageTokenMintVectorMutation, { data, loading, error }] = useUpdateManageTokenMintVectorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateManageTokenMintVectorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateManageTokenMintVectorMutation,
    UpdateManageTokenMintVectorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateManageTokenMintVectorMutation,
    UpdateManageTokenMintVectorMutationVariables
  >(UpdateManageTokenMintVectorDocument, options);
}
export type UpdateManageTokenMintVectorMutationHookResult = ReturnType<
  typeof useUpdateManageTokenMintVectorMutation
>;
export type UpdateManageTokenMintVectorMutationResult =
  Apollo.MutationResult<UpdateManageTokenMintVectorMutation>;
export type UpdateManageTokenMintVectorMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateManageTokenMintVectorMutation,
    UpdateManageTokenMintVectorMutationVariables
  >;
export const UpdateAuctionDocument = gql`
  mutation UpdateAuction($data: AuctionUpdateInput!) {
    auctionUpdate(data: $data) {
      id
      contract {
        address
        args
        chainId
        method
        value
        bytecode
      }
    }
  }
`;
export type UpdateAuctionMutationFn = Apollo.MutationFunction<
  UpdateAuctionMutation,
  UpdateAuctionMutationVariables
>;

/**
 * __useUpdateAuctionMutation__
 *
 * To run a mutation, you first call `useUpdateAuctionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuctionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuctionMutation, { data, loading, error }] = useUpdateAuctionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateAuctionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAuctionMutation,
    UpdateAuctionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAuctionMutation,
    UpdateAuctionMutationVariables
  >(UpdateAuctionDocument, options);
}
export type UpdateAuctionMutationHookResult = ReturnType<
  typeof useUpdateAuctionMutation
>;
export type UpdateAuctionMutationResult =
  Apollo.MutationResult<UpdateAuctionMutation>;
export type UpdateAuctionMutationOptions = Apollo.BaseMutationOptions<
  UpdateAuctionMutation,
  UpdateAuctionMutationVariables
>;
export const GetManageImportTokenDocument = gql`
  query GetManageImportToken($tokenId: String!) {
    getImportedToken(tokenId: $tokenId) {
      id
      name
      address
      tokenId
      chainId
      importData {
        description
        media
        standard
      }
    }
  }
`;

/**
 * __useGetManageImportTokenQuery__
 *
 * To run a query within a React component, call `useGetManageImportTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageImportTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageImportTokenQuery({
 *   variables: {
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useGetManageImportTokenQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetManageImportTokenQuery,
    GetManageImportTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetManageImportTokenQuery,
    GetManageImportTokenQueryVariables
  >(GetManageImportTokenDocument, options);
}
export function useGetManageImportTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManageImportTokenQuery,
    GetManageImportTokenQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetManageImportTokenQuery,
    GetManageImportTokenQueryVariables
  >(GetManageImportTokenDocument, options);
}
export type GetManageImportTokenQueryHookResult = ReturnType<
  typeof useGetManageImportTokenQuery
>;
export type GetManageImportTokenLazyQueryHookResult = ReturnType<
  typeof useGetManageImportTokenLazyQuery
>;
export type GetManageImportTokenQueryResult = Apollo.QueryResult<
  GetManageImportTokenQuery,
  GetManageImportTokenQueryVariables
>;
export const GetRankedAuctionEarningsDocument = gql`
  query GetRankedAuctionEarnings($mintVectorId: String!) {
    rankedAuction(mintVectorId: $mintVectorId) {
      id
      auctionEarningsClaimed
    }
  }
`;

/**
 * __useGetRankedAuctionEarningsQuery__
 *
 * To run a query within a React component, call `useGetRankedAuctionEarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRankedAuctionEarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRankedAuctionEarningsQuery({
 *   variables: {
 *      mintVectorId: // value for 'mintVectorId'
 *   },
 * });
 */
export function useGetRankedAuctionEarningsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRankedAuctionEarningsQuery,
    GetRankedAuctionEarningsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRankedAuctionEarningsQuery,
    GetRankedAuctionEarningsQueryVariables
  >(GetRankedAuctionEarningsDocument, options);
}
export function useGetRankedAuctionEarningsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRankedAuctionEarningsQuery,
    GetRankedAuctionEarningsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRankedAuctionEarningsQuery,
    GetRankedAuctionEarningsQueryVariables
  >(GetRankedAuctionEarningsDocument, options);
}
export type GetRankedAuctionEarningsQueryHookResult = ReturnType<
  typeof useGetRankedAuctionEarningsQuery
>;
export type GetRankedAuctionEarningsLazyQueryHookResult = ReturnType<
  typeof useGetRankedAuctionEarningsLazyQuery
>;
export type GetRankedAuctionEarningsQueryResult = Apollo.QueryResult<
  GetRankedAuctionEarningsQuery,
  GetRankedAuctionEarningsQueryVariables
>;
export const GetManageTokenGateDocument = gql`
  query GetManageTokenGate($id: String!) {
    gate(id: $id) {
      id
      name
    }
  }
`;

/**
 * __useGetManageTokenGateQuery__
 *
 * To run a query within a React component, call `useGetManageTokenGateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageTokenGateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageTokenGateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetManageTokenGateQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetManageTokenGateQuery,
    GetManageTokenGateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetManageTokenGateQuery,
    GetManageTokenGateQueryVariables
  >(GetManageTokenGateDocument, options);
}
export function useGetManageTokenGateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetManageTokenGateQuery,
    GetManageTokenGateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetManageTokenGateQuery,
    GetManageTokenGateQueryVariables
  >(GetManageTokenGateDocument, options);
}
export type GetManageTokenGateQueryHookResult = ReturnType<
  typeof useGetManageTokenGateQuery
>;
export type GetManageTokenGateLazyQueryHookResult = ReturnType<
  typeof useGetManageTokenGateLazyQuery
>;
export type GetManageTokenGateQueryResult = Apollo.QueryResult<
  GetManageTokenGateQuery,
  GetManageTokenGateQueryVariables
>;
export const CollectionDeleteDocument = gql`
  mutation CollectionDelete($id: String!) {
    collectionDelete(id: $id) {
      deletedCount
    }
  }
`;
export type CollectionDeleteMutationFn = Apollo.MutationFunction<
  CollectionDeleteMutation,
  CollectionDeleteMutationVariables
>;

/**
 * __useCollectionDeleteMutation__
 *
 * To run a mutation, you first call `useCollectionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectionDeleteMutation, { data, loading, error }] = useCollectionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCollectionDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CollectionDeleteMutation,
    CollectionDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CollectionDeleteMutation,
    CollectionDeleteMutationVariables
  >(CollectionDeleteDocument, options);
}
export type CollectionDeleteMutationHookResult = ReturnType<
  typeof useCollectionDeleteMutation
>;
export type CollectionDeleteMutationResult =
  Apollo.MutationResult<CollectionDeleteMutation>;
export type CollectionDeleteMutationOptions = Apollo.BaseMutationOptions<
  CollectionDeleteMutation,
  CollectionDeleteMutationVariables
>;
export const DeleteImportedTokenDocument = gql`
  mutation DeleteImportedToken($tokenId: String!) {
    deleteImportedToken(tokenId: $tokenId) {
      deletedCount
    }
  }
`;
export type DeleteImportedTokenMutationFn = Apollo.MutationFunction<
  DeleteImportedTokenMutation,
  DeleteImportedTokenMutationVariables
>;

/**
 * __useDeleteImportedTokenMutation__
 *
 * To run a mutation, you first call `useDeleteImportedTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImportedTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImportedTokenMutation, { data, loading, error }] = useDeleteImportedTokenMutation({
 *   variables: {
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useDeleteImportedTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteImportedTokenMutation,
    DeleteImportedTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteImportedTokenMutation,
    DeleteImportedTokenMutationVariables
  >(DeleteImportedTokenDocument, options);
}
export type DeleteImportedTokenMutationHookResult = ReturnType<
  typeof useDeleteImportedTokenMutation
>;
export type DeleteImportedTokenMutationResult =
  Apollo.MutationResult<DeleteImportedTokenMutation>;
export type DeleteImportedTokenMutationOptions = Apollo.BaseMutationOptions<
  DeleteImportedTokenMutation,
  DeleteImportedTokenMutationVariables
>;
export const UpdateCollectionMetadataDocument = gql`
  mutation UpdateCollectionMetadata(
    $collectionId: String!
    $data: CollectionMetadataUpdate!
  ) {
    updateCollectionMetadata(collectionId: $collectionId, data: $data) {
      ...AllTransactionArgFields
    }
  }
  ${AllTransactionArgFieldsFragmentDoc}
`;
export type UpdateCollectionMetadataMutationFn = Apollo.MutationFunction<
  UpdateCollectionMetadataMutation,
  UpdateCollectionMetadataMutationVariables
>;

/**
 * __useUpdateCollectionMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMetadataMutation, { data, loading, error }] = useUpdateCollectionMetadataMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCollectionMetadataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCollectionMetadataMutation,
    UpdateCollectionMetadataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCollectionMetadataMutation,
    UpdateCollectionMetadataMutationVariables
  >(UpdateCollectionMetadataDocument, options);
}
export type UpdateCollectionMetadataMutationHookResult = ReturnType<
  typeof useUpdateCollectionMetadataMutation
>;
export type UpdateCollectionMetadataMutationResult =
  Apollo.MutationResult<UpdateCollectionMetadataMutation>;
export type UpdateCollectionMetadataMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCollectionMetadataMutation,
    UpdateCollectionMetadataMutationVariables
  >;
export const UpdateCollectionOffChainDocument = gql`
  mutation UpdateCollectionOffChain(
    $data: CollectionUpdateInput!
    $collectionId: String!
  ) {
    collectionUpdate(data: $data, collectionId: $collectionId) {
      creditCardEnabled
      crossmint {
        collectionId
        environment
      }
    }
  }
`;
export type UpdateCollectionOffChainMutationFn = Apollo.MutationFunction<
  UpdateCollectionOffChainMutation,
  UpdateCollectionOffChainMutationVariables
>;

/**
 * __useUpdateCollectionOffChainMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionOffChainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionOffChainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionOffChainMutation, { data, loading, error }] = useUpdateCollectionOffChainMutation({
 *   variables: {
 *      data: // value for 'data'
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useUpdateCollectionOffChainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCollectionOffChainMutation,
    UpdateCollectionOffChainMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCollectionOffChainMutation,
    UpdateCollectionOffChainMutationVariables
  >(UpdateCollectionOffChainDocument, options);
}
export type UpdateCollectionOffChainMutationHookResult = ReturnType<
  typeof useUpdateCollectionOffChainMutation
>;
export type UpdateCollectionOffChainMutationResult =
  Apollo.MutationResult<UpdateCollectionOffChainMutation>;
export type UpdateCollectionOffChainMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCollectionOffChainMutation,
    UpdateCollectionOffChainMutationVariables
  >;
export const CreateManageTokenMintVectorDocument = gql`
  mutation CreateManageTokenMintVector($data: CreateMintVectorInput!) {
    createMintVector(data: $data) {
      id
    }
  }
`;
export type CreateManageTokenMintVectorMutationFn = Apollo.MutationFunction<
  CreateManageTokenMintVectorMutation,
  CreateManageTokenMintVectorMutationVariables
>;

/**
 * __useCreateManageTokenMintVectorMutation__
 *
 * To run a mutation, you first call `useCreateManageTokenMintVectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManageTokenMintVectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManageTokenMintVectorMutation, { data, loading, error }] = useCreateManageTokenMintVectorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateManageTokenMintVectorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateManageTokenMintVectorMutation,
    CreateManageTokenMintVectorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateManageTokenMintVectorMutation,
    CreateManageTokenMintVectorMutationVariables
  >(CreateManageTokenMintVectorDocument, options);
}
export type CreateManageTokenMintVectorMutationHookResult = ReturnType<
  typeof useCreateManageTokenMintVectorMutation
>;
export type CreateManageTokenMintVectorMutationResult =
  Apollo.MutationResult<CreateManageTokenMintVectorMutation>;
export type CreateManageTokenMintVectorMutationOptions =
  Apollo.BaseMutationOptions<
    CreateManageTokenMintVectorMutation,
    CreateManageTokenMintVectorMutationVariables
  >;
export const GetUpdateMintVectorTxArgsDocument = gql`
  query GetUpdateMintVectorTxArgs(
    $mintVectorId: String!
    $data: OnChainMintVectorUpdateInput!
  ) {
    mintVectorUpdateTxArgs(mintVectorId: $mintVectorId, data: $data) {
      ...AllTransactionArgFields
    }
  }
  ${AllTransactionArgFieldsFragmentDoc}
`;

/**
 * __useGetUpdateMintVectorTxArgsQuery__
 *
 * To run a query within a React component, call `useGetUpdateMintVectorTxArgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdateMintVectorTxArgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdateMintVectorTxArgsQuery({
 *   variables: {
 *      mintVectorId: // value for 'mintVectorId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetUpdateMintVectorTxArgsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUpdateMintVectorTxArgsQuery,
    GetUpdateMintVectorTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUpdateMintVectorTxArgsQuery,
    GetUpdateMintVectorTxArgsQueryVariables
  >(GetUpdateMintVectorTxArgsDocument, options);
}
export function useGetUpdateMintVectorTxArgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUpdateMintVectorTxArgsQuery,
    GetUpdateMintVectorTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUpdateMintVectorTxArgsQuery,
    GetUpdateMintVectorTxArgsQueryVariables
  >(GetUpdateMintVectorTxArgsDocument, options);
}
export type GetUpdateMintVectorTxArgsQueryHookResult = ReturnType<
  typeof useGetUpdateMintVectorTxArgsQuery
>;
export type GetUpdateMintVectorTxArgsLazyQueryHookResult = ReturnType<
  typeof useGetUpdateMintVectorTxArgsLazyQuery
>;
export type GetUpdateMintVectorTxArgsQueryResult = Apollo.QueryResult<
  GetUpdateMintVectorTxArgsQuery,
  GetUpdateMintVectorTxArgsQueryVariables
>;
export const GetCreateMintVectorTxArgsDocument = gql`
  query GetCreateMintVectorTxArgs(
    $collectionId: String!
    $data: OnChainMintVectorCreateInput!
  ) {
    mintVectorCreateTxArgs(collectionId: $collectionId, data: $data) {
      ...AllTransactionArgFields
    }
  }
  ${AllTransactionArgFieldsFragmentDoc}
`;

/**
 * __useGetCreateMintVectorTxArgsQuery__
 *
 * To run a query within a React component, call `useGetCreateMintVectorTxArgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateMintVectorTxArgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateMintVectorTxArgsQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCreateMintVectorTxArgsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCreateMintVectorTxArgsQuery,
    GetCreateMintVectorTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCreateMintVectorTxArgsQuery,
    GetCreateMintVectorTxArgsQueryVariables
  >(GetCreateMintVectorTxArgsDocument, options);
}
export function useGetCreateMintVectorTxArgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCreateMintVectorTxArgsQuery,
    GetCreateMintVectorTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCreateMintVectorTxArgsQuery,
    GetCreateMintVectorTxArgsQueryVariables
  >(GetCreateMintVectorTxArgsDocument, options);
}
export type GetCreateMintVectorTxArgsQueryHookResult = ReturnType<
  typeof useGetCreateMintVectorTxArgsQuery
>;
export type GetCreateMintVectorTxArgsLazyQueryHookResult = ReturnType<
  typeof useGetCreateMintVectorTxArgsLazyQuery
>;
export type GetCreateMintVectorTxArgsQueryResult = Apollo.QueryResult<
  GetCreateMintVectorTxArgsQuery,
  GetCreateMintVectorTxArgsQueryVariables
>;
export const GetUpdateDutchAuctionTxArgsDocument = gql`
  query GetUpdateDutchAuctionTxArgs(
    $mintVectorId: String!
    $data: OnChainDutchAuctionUpdateInput!
  ) {
    dutchAuctionUpdateTxArgs(mintVectorId: $mintVectorId, data: $data) {
      ...AllTransactionArgFields
    }
  }
  ${AllTransactionArgFieldsFragmentDoc}
`;

/**
 * __useGetUpdateDutchAuctionTxArgsQuery__
 *
 * To run a query within a React component, call `useGetUpdateDutchAuctionTxArgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdateDutchAuctionTxArgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdateDutchAuctionTxArgsQuery({
 *   variables: {
 *      mintVectorId: // value for 'mintVectorId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetUpdateDutchAuctionTxArgsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUpdateDutchAuctionTxArgsQuery,
    GetUpdateDutchAuctionTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUpdateDutchAuctionTxArgsQuery,
    GetUpdateDutchAuctionTxArgsQueryVariables
  >(GetUpdateDutchAuctionTxArgsDocument, options);
}
export function useGetUpdateDutchAuctionTxArgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUpdateDutchAuctionTxArgsQuery,
    GetUpdateDutchAuctionTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUpdateDutchAuctionTxArgsQuery,
    GetUpdateDutchAuctionTxArgsQueryVariables
  >(GetUpdateDutchAuctionTxArgsDocument, options);
}
export type GetUpdateDutchAuctionTxArgsQueryHookResult = ReturnType<
  typeof useGetUpdateDutchAuctionTxArgsQuery
>;
export type GetUpdateDutchAuctionTxArgsLazyQueryHookResult = ReturnType<
  typeof useGetUpdateDutchAuctionTxArgsLazyQuery
>;
export type GetUpdateDutchAuctionTxArgsQueryResult = Apollo.QueryResult<
  GetUpdateDutchAuctionTxArgsQuery,
  GetUpdateDutchAuctionTxArgsQueryVariables
>;
export const GetUpdateRankedAuctionTxArgsDocument = gql`
  query GetUpdateRankedAuctionTxArgs(
    $mintVectorId: String!
    $data: OnChainRankedAuctionUpdateInput!
  ) {
    rankedAuctionUpdateTxArgs(mintVectorId: $mintVectorId, data: $data) {
      ...AllTransactionArgFields
    }
  }
  ${AllTransactionArgFieldsFragmentDoc}
`;

/**
 * __useGetUpdateRankedAuctionTxArgsQuery__
 *
 * To run a query within a React component, call `useGetUpdateRankedAuctionTxArgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdateRankedAuctionTxArgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdateRankedAuctionTxArgsQuery({
 *   variables: {
 *      mintVectorId: // value for 'mintVectorId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetUpdateRankedAuctionTxArgsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUpdateRankedAuctionTxArgsQuery,
    GetUpdateRankedAuctionTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUpdateRankedAuctionTxArgsQuery,
    GetUpdateRankedAuctionTxArgsQueryVariables
  >(GetUpdateRankedAuctionTxArgsDocument, options);
}
export function useGetUpdateRankedAuctionTxArgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUpdateRankedAuctionTxArgsQuery,
    GetUpdateRankedAuctionTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUpdateRankedAuctionTxArgsQuery,
    GetUpdateRankedAuctionTxArgsQueryVariables
  >(GetUpdateRankedAuctionTxArgsDocument, options);
}
export type GetUpdateRankedAuctionTxArgsQueryHookResult = ReturnType<
  typeof useGetUpdateRankedAuctionTxArgsQuery
>;
export type GetUpdateRankedAuctionTxArgsLazyQueryHookResult = ReturnType<
  typeof useGetUpdateRankedAuctionTxArgsLazyQuery
>;
export type GetUpdateRankedAuctionTxArgsQueryResult = Apollo.QueryResult<
  GetUpdateRankedAuctionTxArgsQuery,
  GetUpdateRankedAuctionTxArgsQueryVariables
>;
export const GetUpdatePauseRankedAuctionTxArgsDocument = gql`
  query GetUpdatePauseRankedAuctionTxArgs(
    $mintVectorId: String!
    $paused: Boolean!
  ) {
    rankedAuctionUpdatePauseTxArgs(
      mintVectorId: $mintVectorId
      paused: $paused
    ) {
      ...AllTransactionArgFields
    }
  }
  ${AllTransactionArgFieldsFragmentDoc}
`;

/**
 * __useGetUpdatePauseRankedAuctionTxArgsQuery__
 *
 * To run a query within a React component, call `useGetUpdatePauseRankedAuctionTxArgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdatePauseRankedAuctionTxArgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdatePauseRankedAuctionTxArgsQuery({
 *   variables: {
 *      mintVectorId: // value for 'mintVectorId'
 *      paused: // value for 'paused'
 *   },
 * });
 */
export function useGetUpdatePauseRankedAuctionTxArgsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUpdatePauseRankedAuctionTxArgsQuery,
    GetUpdatePauseRankedAuctionTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUpdatePauseRankedAuctionTxArgsQuery,
    GetUpdatePauseRankedAuctionTxArgsQueryVariables
  >(GetUpdatePauseRankedAuctionTxArgsDocument, options);
}
export function useGetUpdatePauseRankedAuctionTxArgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUpdatePauseRankedAuctionTxArgsQuery,
    GetUpdatePauseRankedAuctionTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUpdatePauseRankedAuctionTxArgsQuery,
    GetUpdatePauseRankedAuctionTxArgsQueryVariables
  >(GetUpdatePauseRankedAuctionTxArgsDocument, options);
}
export type GetUpdatePauseRankedAuctionTxArgsQueryHookResult = ReturnType<
  typeof useGetUpdatePauseRankedAuctionTxArgsQuery
>;
export type GetUpdatePauseRankedAuctionTxArgsLazyQueryHookResult = ReturnType<
  typeof useGetUpdatePauseRankedAuctionTxArgsLazyQuery
>;
export type GetUpdatePauseRankedAuctionTxArgsQueryResult = Apollo.QueryResult<
  GetUpdatePauseRankedAuctionTxArgsQuery,
  GetUpdatePauseRankedAuctionTxArgsQueryVariables
>;
export const GetClaimRankedAuctionEarningsTxArgsDocument = gql`
  query GetClaimRankedAuctionEarningsTxArgs($mintVectorId: String!) {
    rankedAuctionClaimAuctionEarningsTxArgs(mintVectorId: $mintVectorId) {
      ...AllTransactionArgFields
    }
  }
  ${AllTransactionArgFieldsFragmentDoc}
`;

/**
 * __useGetClaimRankedAuctionEarningsTxArgsQuery__
 *
 * To run a query within a React component, call `useGetClaimRankedAuctionEarningsTxArgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimRankedAuctionEarningsTxArgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimRankedAuctionEarningsTxArgsQuery({
 *   variables: {
 *      mintVectorId: // value for 'mintVectorId'
 *   },
 * });
 */
export function useGetClaimRankedAuctionEarningsTxArgsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClaimRankedAuctionEarningsTxArgsQuery,
    GetClaimRankedAuctionEarningsTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClaimRankedAuctionEarningsTxArgsQuery,
    GetClaimRankedAuctionEarningsTxArgsQueryVariables
  >(GetClaimRankedAuctionEarningsTxArgsDocument, options);
}
export function useGetClaimRankedAuctionEarningsTxArgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClaimRankedAuctionEarningsTxArgsQuery,
    GetClaimRankedAuctionEarningsTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClaimRankedAuctionEarningsTxArgsQuery,
    GetClaimRankedAuctionEarningsTxArgsQueryVariables
  >(GetClaimRankedAuctionEarningsTxArgsDocument, options);
}
export type GetClaimRankedAuctionEarningsTxArgsQueryHookResult = ReturnType<
  typeof useGetClaimRankedAuctionEarningsTxArgsQuery
>;
export type GetClaimRankedAuctionEarningsTxArgsLazyQueryHookResult = ReturnType<
  typeof useGetClaimRankedAuctionEarningsTxArgsLazyQuery
>;
export type GetClaimRankedAuctionEarningsTxArgsQueryResult = Apollo.QueryResult<
  GetClaimRankedAuctionEarningsTxArgsQuery,
  GetClaimRankedAuctionEarningsTxArgsQueryVariables
>;
export const GetUpdatePauseDutchAuctionTxArgsDocument = gql`
  query GetUpdatePauseDutchAuctionTxArgs(
    $mintVectorId: String!
    $paused: Boolean!
  ) {
    dutchAuctionUpdatePauseTxArgs(
      mintVectorId: $mintVectorId
      paused: $paused
    ) {
      ...AllTransactionArgFields
    }
  }
  ${AllTransactionArgFieldsFragmentDoc}
`;

/**
 * __useGetUpdatePauseDutchAuctionTxArgsQuery__
 *
 * To run a query within a React component, call `useGetUpdatePauseDutchAuctionTxArgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdatePauseDutchAuctionTxArgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdatePauseDutchAuctionTxArgsQuery({
 *   variables: {
 *      mintVectorId: // value for 'mintVectorId'
 *      paused: // value for 'paused'
 *   },
 * });
 */
export function useGetUpdatePauseDutchAuctionTxArgsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUpdatePauseDutchAuctionTxArgsQuery,
    GetUpdatePauseDutchAuctionTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUpdatePauseDutchAuctionTxArgsQuery,
    GetUpdatePauseDutchAuctionTxArgsQueryVariables
  >(GetUpdatePauseDutchAuctionTxArgsDocument, options);
}
export function useGetUpdatePauseDutchAuctionTxArgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUpdatePauseDutchAuctionTxArgsQuery,
    GetUpdatePauseDutchAuctionTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUpdatePauseDutchAuctionTxArgsQuery,
    GetUpdatePauseDutchAuctionTxArgsQueryVariables
  >(GetUpdatePauseDutchAuctionTxArgsDocument, options);
}
export type GetUpdatePauseDutchAuctionTxArgsQueryHookResult = ReturnType<
  typeof useGetUpdatePauseDutchAuctionTxArgsQuery
>;
export type GetUpdatePauseDutchAuctionTxArgsLazyQueryHookResult = ReturnType<
  typeof useGetUpdatePauseDutchAuctionTxArgsLazyQuery
>;
export type GetUpdatePauseDutchAuctionTxArgsQueryResult = Apollo.QueryResult<
  GetUpdatePauseDutchAuctionTxArgsQuery,
  GetUpdatePauseDutchAuctionTxArgsQueryVariables
>;
export const GetCreateDutchAuctionTxArgsDocument = gql`
  query GetCreateDutchAuctionTxArgs(
    $collectionId: String!
    $data: OnChainDutchAuctionCreateInput!
  ) {
    dutchAuctionMechanicVectorCreateTxArgs(
      collectionId: $collectionId
      data: $data
    ) {
      ...AllTransactionArgFields
    }
  }
  ${AllTransactionArgFieldsFragmentDoc}
`;

/**
 * __useGetCreateDutchAuctionTxArgsQuery__
 *
 * To run a query within a React component, call `useGetCreateDutchAuctionTxArgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateDutchAuctionTxArgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateDutchAuctionTxArgsQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCreateDutchAuctionTxArgsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCreateDutchAuctionTxArgsQuery,
    GetCreateDutchAuctionTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCreateDutchAuctionTxArgsQuery,
    GetCreateDutchAuctionTxArgsQueryVariables
  >(GetCreateDutchAuctionTxArgsDocument, options);
}
export function useGetCreateDutchAuctionTxArgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCreateDutchAuctionTxArgsQuery,
    GetCreateDutchAuctionTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCreateDutchAuctionTxArgsQuery,
    GetCreateDutchAuctionTxArgsQueryVariables
  >(GetCreateDutchAuctionTxArgsDocument, options);
}
export type GetCreateDutchAuctionTxArgsQueryHookResult = ReturnType<
  typeof useGetCreateDutchAuctionTxArgsQuery
>;
export type GetCreateDutchAuctionTxArgsLazyQueryHookResult = ReturnType<
  typeof useGetCreateDutchAuctionTxArgsLazyQuery
>;
export type GetCreateDutchAuctionTxArgsQueryResult = Apollo.QueryResult<
  GetCreateDutchAuctionTxArgsQuery,
  GetCreateDutchAuctionTxArgsQueryVariables
>;
export const GetClaimFundsDutchAuctionTxArgsDocument = gql`
  query GetClaimFundsDutchAuctionTxArgs($vectorId: String!) {
    dutchAuctionClaimFundsTxArgs(vectorId: $vectorId) {
      ...AllTransactionArgFields
    }
  }
  ${AllTransactionArgFieldsFragmentDoc}
`;

/**
 * __useGetClaimFundsDutchAuctionTxArgsQuery__
 *
 * To run a query within a React component, call `useGetClaimFundsDutchAuctionTxArgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClaimFundsDutchAuctionTxArgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClaimFundsDutchAuctionTxArgsQuery({
 *   variables: {
 *      vectorId: // value for 'vectorId'
 *   },
 * });
 */
export function useGetClaimFundsDutchAuctionTxArgsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClaimFundsDutchAuctionTxArgsQuery,
    GetClaimFundsDutchAuctionTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClaimFundsDutchAuctionTxArgsQuery,
    GetClaimFundsDutchAuctionTxArgsQueryVariables
  >(GetClaimFundsDutchAuctionTxArgsDocument, options);
}
export function useGetClaimFundsDutchAuctionTxArgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClaimFundsDutchAuctionTxArgsQuery,
    GetClaimFundsDutchAuctionTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClaimFundsDutchAuctionTxArgsQuery,
    GetClaimFundsDutchAuctionTxArgsQueryVariables
  >(GetClaimFundsDutchAuctionTxArgsDocument, options);
}
export type GetClaimFundsDutchAuctionTxArgsQueryHookResult = ReturnType<
  typeof useGetClaimFundsDutchAuctionTxArgsQuery
>;
export type GetClaimFundsDutchAuctionTxArgsLazyQueryHookResult = ReturnType<
  typeof useGetClaimFundsDutchAuctionTxArgsLazyQuery
>;
export type GetClaimFundsDutchAuctionTxArgsQueryResult = Apollo.QueryResult<
  GetClaimFundsDutchAuctionTxArgsQuery,
  GetClaimFundsDutchAuctionTxArgsQueryVariables
>;
export const CrossmintStatusDocument = gql`
  query CrossmintStatus($isTestnet: Boolean!, $cmCollectionId: String!) {
    crossmintVerificationStatus(
      isTestnet: $isTestnet
      cmCollectionId: $cmCollectionId
    ) {
      id
      seller {
        status
      }
      collection {
        status
      }
    }
  }
`;

/**
 * __useCrossmintStatusQuery__
 *
 * To run a query within a React component, call `useCrossmintStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrossmintStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrossmintStatusQuery({
 *   variables: {
 *      isTestnet: // value for 'isTestnet'
 *      cmCollectionId: // value for 'cmCollectionId'
 *   },
 * });
 */
export function useCrossmintStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    CrossmintStatusQuery,
    CrossmintStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CrossmintStatusQuery, CrossmintStatusQueryVariables>(
    CrossmintStatusDocument,
    options
  );
}
export function useCrossmintStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CrossmintStatusQuery,
    CrossmintStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CrossmintStatusQuery,
    CrossmintStatusQueryVariables
  >(CrossmintStatusDocument, options);
}
export type CrossmintStatusQueryHookResult = ReturnType<
  typeof useCrossmintStatusQuery
>;
export type CrossmintStatusLazyQueryHookResult = ReturnType<
  typeof useCrossmintStatusLazyQuery
>;
export type CrossmintStatusQueryResult = Apollo.QueryResult<
  CrossmintStatusQuery,
  CrossmintStatusQueryVariables
>;
export const GetCreatorReservesTxArgsDocument = gql`
  query GetCreatorReservesTxArgs(
    $collectionId: String!
    $data: CreatorReservesInput!
  ) {
    creatorReservesTxArgs(collectionId: $collectionId, data: $data) {
      ...AllTransactionArgFields
    }
  }
  ${AllTransactionArgFieldsFragmentDoc}
`;

/**
 * __useGetCreatorReservesTxArgsQuery__
 *
 * To run a query within a React component, call `useGetCreatorReservesTxArgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorReservesTxArgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorReservesTxArgsQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetCreatorReservesTxArgsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCreatorReservesTxArgsQuery,
    GetCreatorReservesTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCreatorReservesTxArgsQuery,
    GetCreatorReservesTxArgsQueryVariables
  >(GetCreatorReservesTxArgsDocument, options);
}
export function useGetCreatorReservesTxArgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCreatorReservesTxArgsQuery,
    GetCreatorReservesTxArgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCreatorReservesTxArgsQuery,
    GetCreatorReservesTxArgsQueryVariables
  >(GetCreatorReservesTxArgsDocument, options);
}
export type GetCreatorReservesTxArgsQueryHookResult = ReturnType<
  typeof useGetCreatorReservesTxArgsQuery
>;
export type GetCreatorReservesTxArgsLazyQueryHookResult = ReturnType<
  typeof useGetCreatorReservesTxArgsLazyQuery
>;
export type GetCreatorReservesTxArgsQueryResult = Apollo.QueryResult<
  GetCreatorReservesTxArgsQuery,
  GetCreatorReservesTxArgsQueryVariables
>;
export const UpdatePaymentRecipientOnPrivateSalesDocument = gql`
  mutation UpdatePaymentRecipientOnPrivateSales(
    $collectionId: String!
    $paymentRecipient: String!
  ) {
    updatePaymentRecipientOnPrivateSales(
      collectionId: $collectionId
      paymentRecipient: $paymentRecipient
    )
  }
`;
export type UpdatePaymentRecipientOnPrivateSalesMutationFn =
  Apollo.MutationFunction<
    UpdatePaymentRecipientOnPrivateSalesMutation,
    UpdatePaymentRecipientOnPrivateSalesMutationVariables
  >;

/**
 * __useUpdatePaymentRecipientOnPrivateSalesMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentRecipientOnPrivateSalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentRecipientOnPrivateSalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentRecipientOnPrivateSalesMutation, { data, loading, error }] = useUpdatePaymentRecipientOnPrivateSalesMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      paymentRecipient: // value for 'paymentRecipient'
 *   },
 * });
 */
export function useUpdatePaymentRecipientOnPrivateSalesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePaymentRecipientOnPrivateSalesMutation,
    UpdatePaymentRecipientOnPrivateSalesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePaymentRecipientOnPrivateSalesMutation,
    UpdatePaymentRecipientOnPrivateSalesMutationVariables
  >(UpdatePaymentRecipientOnPrivateSalesDocument, options);
}
export type UpdatePaymentRecipientOnPrivateSalesMutationHookResult = ReturnType<
  typeof useUpdatePaymentRecipientOnPrivateSalesMutation
>;
export type UpdatePaymentRecipientOnPrivateSalesMutationResult =
  Apollo.MutationResult<UpdatePaymentRecipientOnPrivateSalesMutation>;
export type UpdatePaymentRecipientOnPrivateSalesMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePaymentRecipientOnPrivateSalesMutation,
    UpdatePaymentRecipientOnPrivateSalesMutationVariables
  >;
export const CollectionTokensDocument = gql`
  query CollectionTokens(
    $chainId: Float!
    $tokenAddress: String!
    $first: Float
    $after: String
    $sortBy: TokenSortOptions
    $sortDirection: SortDirection
    $tokenNameOrId: String
    $withListings: Boolean
    $withOffers: Boolean
    $attributes: [MarketplaceCollectionAttributesFilter!]
    $minted: Boolean
  ) {
    getCollectionTokens(
      chainId: $chainId
      tokenAddress: $tokenAddress
      first: $first
      after: $after
      sortBy: $sortBy
      sortDirection: $sortDirection
      tokenNameOrId: $tokenNameOrId
      withListings: $withListings
      withOffers: $withOffers
      attributes: $attributes
      minted: $minted
    ) {
      edges {
        id
        tokenId
        name
        imageUrl
        animationUrl
        minted
      }
      pageInfo {
        hasNextPage
        endCursor
        totalCount
      }
    }
  }
`;

/**
 * __useCollectionTokensQuery__
 *
 * To run a query within a React component, call `useCollectionTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionTokensQuery({
 *   variables: {
 *      chainId: // value for 'chainId'
 *      tokenAddress: // value for 'tokenAddress'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *      tokenNameOrId: // value for 'tokenNameOrId'
 *      withListings: // value for 'withListings'
 *      withOffers: // value for 'withOffers'
 *      attributes: // value for 'attributes'
 *      minted: // value for 'minted'
 *   },
 * });
 */
export function useCollectionTokensQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionTokensQuery,
    CollectionTokensQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CollectionTokensQuery, CollectionTokensQueryVariables>(
    CollectionTokensDocument,
    options
  );
}
export function useCollectionTokensLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionTokensQuery,
    CollectionTokensQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectionTokensQuery,
    CollectionTokensQueryVariables
  >(CollectionTokensDocument, options);
}
export type CollectionTokensQueryHookResult = ReturnType<
  typeof useCollectionTokensQuery
>;
export type CollectionTokensLazyQueryHookResult = ReturnType<
  typeof useCollectionTokensLazyQuery
>;
export type CollectionTokensQueryResult = Apollo.QueryResult<
  CollectionTokensQuery,
  CollectionTokensQueryVariables
>;
